import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "font-normal" }, "Achievements", -1)
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "w-9" }
const _hoisted_4 = { class: "w-4/5" }
const _hoisted_5 = { class: "flex justify-end w-9" }

import IconComponent from '../icon/IconComponent.vue';
import Icon from '../icon/Icon';
import { useGlobalStore } from '../../store/globalStore';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref } from 'vue';
import { Carousel, Slide } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import { Achievement } from '../../models/Achievement';


export default /*#__PURE__*/_defineComponent({
  __name: 'AchievementCarouselComponent',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as {
  items: Achievement[];
}

const store = useGlobalStore();
const { currentUser } = storeToRefs(store);
const handleBadgeClick = (badgeId: string) => {
  store.viewAchievementEvent(currentUser.value?.uid || '', badgeId);
};


// Warning: Carousel component contains dragons
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const carousel = ref(null) as any;

onMounted(() => {
  setTimeout(() => {
    if (carousel.value) {
      // Weird bug where the carousel doesn't render properly unless you restart it
      carousel.value.restartCarousel();
    }
  }, 200);
});

const next = () => {
  if (carousel.value) {
    carousel.value.next();
  }
};

const prev = () => {
  if (carousel.value) {
    carousel.value.prev();
  }
};

const sortArray = (achievements: Achievement[]) => {
  // Sort by date achieved, then alternate between the two halves
  // so that the middle is the most recent and the outermost is the oldest
  const sorted = achievements.sort(
    (a, b) => b.dateAchieved.getTime() - a.dateAchieved.getTime()
  );
  // Warning: Carousel component contains dragons
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result: any[] = [];
  for (let i = 0; i < sorted.length; i++) {
    if (i % 2 === 0) {
      result.push(sorted[i]);
    } else {
      result.unshift(sorted[i]);
    }
  }
  return result;
};

const renderableItems = computed(() => {
  const sortedItems = sortArray(props.items);

  // Add octogons to fill the space if there are less than 7 items
  const numberOfOctogons = 7 - sortedItems.length;
  const octogons = Array.from({ length: numberOfOctogons }, () => ({
    id: 'octogon' + Math.random(),
    icon: Icon.BADGE_BLANK
  }));
  const middleIndex = Math.floor(numberOfOctogons / 2);
  const firstHalf = octogons.slice(0, middleIndex);
  const secondHalf = octogons.slice(middleIndex);
  return [...firstHalf, ...sortedItems, ...secondHalf];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(IconComponent, {
          icon: _unref(Icon).NAVIGATE_LEFT_BUTTON,
          onClick: prev
        }, null, 8, ["icon"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Carousel), {
          modelValue: 3,
          "items-to-show": 7,
          "wrap-around": true,
          ref_key: "carousel",
          ref: carousel
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(renderableItems), (item) => {
              return (_openBlock(), _createBlock(_unref(Slide), {
                key: item.id
              }, {
                default: _withCtx(() => [
                  _createVNode(IconComponent, {
                    icon: item.icon,
                    class: "badge",
                    onClick: ($event: any) => (handleBadgeClick(item.id))
                  }, null, 8, ["icon", "onClick"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 512)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(IconComponent, {
          icon: _unref(Icon).NAVIGATE_RIGHT_BUTTON,
          onClick: next
        }, null, 8, ["icon"])
      ])
    ])
  ]))
}
}

})